export default __webpack_public_path__ + "static/media/caleb-lightning-icon.c7de82c7.svg";